import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { jwtDecode } from "jwt-decode";
import { format } from "date-fns";
import { DateTime } from "luxon";

import ModalWarning from "../../Components/ModalWarning/ModalWarning";
import ModalConfirmation from "../../Components/ModalConfirmation/ModalConfirmation";
import DotsMenu from "../../Components/DotsMenu";
import ScrollableItems from "../../Components/ScrollableItems";
import ScheduleInviteInput from "../../Components/ScheduleInviteInput/ScheduleInviteInput";

import { monthNames } from "../../store/GlobalVarriables";
import useApi from "../../hooks/useApi";
import { useStatusModal } from "../../context/StatusModalContext";
import { getNext30Days } from "../../helpers/days";

import { ReactComponent as Warning } from "../../static/images/exclamation_sign.svg";
import { ReactComponent as Tick } from "../../static/images/tick_sign.svg";

import { ReactComponent as Tennis } from "../../static/images/consumer_tennis.svg";
import { ReactComponent as Boxing } from "../../static/images/consumer_boxing.svg";
import { ReactComponent as Yoga } from "../../static/images/consumer_yoga.svg";
import { ReactComponent as Gym } from "../../static/images/consumer_gym.svg";
import { ReactComponent as Soccer } from "../../static/images/consumer_soccer.svg";
import { ReactComponent as Basketball } from "../../static/images/consumer_basketball.svg";
import { ReactComponent as Dance } from "../../static/images/dance.svg";
import { ReactComponent as Other } from "../../static/images/consumer_other.svg";

import { ReactComponent as MMA } from "../../static/images/mma.svg";
import { ReactComponent as Padel } from "../../static/images/padel.svg";
import { ReactComponent as Pickleball } from "../../static/images/pickleball.svg";
import { ReactComponent as AmericanBall } from "../../static/images/american_ball.svg";
import { ReactComponent as Judo } from "../../static/images/judo.svg";
import { ReactComponent as Golf } from "../../static/images/golf.svg";
import { ReactComponent as Baseball } from "../../static/images/baseball.svg";
import { ReactComponent as Karate } from "../../static/images/karate.svg";
import { ReactComponent as Ballet } from "../../static/images/ballet.svg";
import { ReactComponent as HipHop } from "../../static/images/hip_hop.svg";
import { ReactComponent as Gymnastics } from "../../static/images/gymnastics.svg";
import { ReactComponent as PersonalTrainer } from "../../static/images/presonal_trainer.svg";

import "./style.scss";

const ScheduleConsumer = () => {
  const { post, patch, get, loading } = useApi();
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { showStatusModal } = useStatusModal();
  const eventsRefs = useRef([]);

  const [subscriptionEventData, setSubscriptionEventData] = useState([]);
  const [dataForDays, setDataForDays] = useState([]);

  const [days, setDays] = useState([]);
  const [activeDay, setActiveDay] = useState(0);
  const [scrollByCode, setScrollByCode] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);

  const [warningModalToggle, setWarningModalToggle] = useState("");
  const [warningModalText, setWarningModalText] = useState("");
  const [confirmModalToggle, setConfirmModalToggle] = useState("");
  const [detectModal, setDetectModal] = useState(0);

  const [selectedItem, setSelectedItem] = useState(null);

  const [inputNameValue, setInputNameValue] = useState([]);

  let targetList = [];

  const menuItems = [
    {
      text: t("cancel"),
      onClick: () => {
        if (selectedItem?.customerCanCancel === false) {
          return;
        }
        setDetectModal(1);
        setConfirmModalToggle("modal-confirm");
      },
      disabled: selectedItem?.customerCanCancel === true ? false : true,
    },

    {
      text: t("reschedule"),
      onClick: () => {},
      disabled: true,
    },
    {
      text: t("rename"),
      onClick: () => {
        setDetectModal(2);
        setConfirmModalToggle("modal-confirm");
      },
    },
  ];

  const RenderActivities = ({ activities }) => {
    const activityIcons = {
      tennis: <Tennis />,
      boxing: <Boxing />,
      yoga: <Yoga />,
      soccer: <Soccer />,
      basketball: <Basketball />,
      "personal trainer": <PersonalTrainer />,
      mma: <MMA />,
      padel: <Padel />,
      pickleball: <Pickleball />,
      "american football": <AmericanBall />,
      judo: <Judo />,
      baseball: <Baseball />,
      golf: <Golf />,
      karate: <Karate />,
      ballet: <Ballet />,
      "hip-hop": <HipHop />,
      "ballroom dance": <Dance />,
      gymnastics: <Gymnastics />,
      fitness: <Gym />,
      other: <Other />,
    };

    return <>{activityIcons[activities] || activityIcons["other"]}</>;
  };

  const fetchInvitation = async () => {
    const ps10005000 = JSON.parse(localStorage.getItem("ps10005000"));

    const encodedToken = jwtDecode(ps10005000);

    try {
      const data = await get(
        `/Invitation?PhoneNumber=${encodedToken.sub}&Email=${encodeURIComponent(encodedToken.email)}&Status=Pending`,
      );
      if (data.length) {
        setWarningModalToggle("modal-warning");
        setWarningModalText(t("consumer_schedules_pending_warning"));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getSubscriptionEvents = async () => {
    const ps10005000 = JSON.parse(localStorage.getItem("ps10005000"));
    const encodedToken = jwtDecode(ps10005000);

    const timezone = DateTime.now().zoneName;
    try {
      const data = await post(`/UpcomingEvents/Consumer`, {
        consumerId: encodedToken.buid,
        timezone: timezone,
      });
      margeSchedule(data);
    } catch (error) {
      console.error(error);
    }
  };

  function generateUniqueId() {
    const timestamp = new Date().getTime();
    const random = Math.random().toString(36).substring(2, 8);
    return `${timestamp}${random}`;
  }

  // function getAllDatesForWeekdayInRange(startDate, endDate, targetDayOfWeek) {
  //   let currentDay = startDate.getDay();
  //   let daysToAdd = targetDayOfWeek - currentDay;
  //   if (daysToAdd < 0) {
  //     daysToAdd += 7;
  //   }
  //   let currentDate = new Date(startDate.getTime());
  //   currentDate.setDate(startDate.getDate() + daysToAdd);
  //   const dates = [];
  //   while (currentDate <= endDate) {
  //     dates.push(new Date(currentDate.getTime())); // Clone the date to avoid reference issues
  //     currentDate.setDate(currentDate.getDate() + 7); // Move to the next week
  //   }
  //   return dates;
  // }

  function getDayOfWeek(day) {
    switch (day) {
      case "Monday":
        return 1;
      case "Tuesday":
        return 2;
      case "Wednesday":
        return 3;
      case "Thursday":
        return 4;
      case "Friday":
        return 5;
      case "Saturday":
        return 6;
      case "Sunday":
        return 0;
      default:
        throw Error;
    }
  }

  const margeSchedule = (subscriptionData) => {
    if (!subscriptionData.length) {
      return;
    }

    subscriptionData.forEach((subscription) => {
      subscription.events.forEach((sessionDate) => {
        const weekDay = new Date(sessionDate.eventDate).toLocaleString(
          "en-US",
          {
            weekday: "long",
          },
        );

        const newDate = new Date(sessionDate.eventDate);
        const originalDate = sessionDate.originalEventDate
          ? new Date(sessionDate.originalEventDate)
          : newDate;

        const newScheduleTimes = {
          hour: String(newDate.getHours()).padStart(2, "0"),
          minute: String(newDate.getMinutes()).padStart(2, "0"),
          second: String(newDate.getSeconds()).padStart(2, "0"),
        };

        const originalScheduleTimes = sessionDate.originalEventDate
          ? {
              hour: String(originalDate.getHours()).padStart(2, "0"),
              minute: String(originalDate.getMinutes()).padStart(2, "0"),
              second: String(originalDate.getSeconds()).padStart(2, "0"),
            }
          : newScheduleTimes;

        let tempObject = {
          MonthName: monthNames[newDate.getMonth()],
          WeekDay: weekDay,
          OriginalScheduledDate: originalDate,
          NewScheduledDate: newDate,
          data: [
            {
              OriginalScheduledDate: originalDate,
              NewScheduledDate: newDate,

              scheduleId: subscription.scheduleId,

              dayId: sessionDate.scheduleDayId,
              subscriptionId: subscription.subscriptionId,

              OriginalScheduledTimeOnly: originalScheduleTimes,
              NewScheduledTimeOnly: newScheduleTimes,
              ScheduleDescription: subscription.description,
              guid: generateUniqueId(),
              customerCanCancel: subscription.conusmerCanCancel,
              scheduleActivityName: subscription.scheduleActivityName || "",
            },
          ],
        };

        targetList.push(tempObject);
      });
    });

    targetList.sort((a, b) => a.NewScheduledDate - b.NewScheduledDate);

    let mergedSubscriptionData = [];

    targetList.forEach((item) => {
      let existingItemIndex = mergedSubscriptionData.findIndex(
        (mergedItem) =>
          mergedItem.NewScheduledDate.getFullYear() ===
            item.NewScheduledDate.getFullYear() &&
          mergedItem.NewScheduledDate.getMonth() ===
            item.NewScheduledDate.getMonth() &&
          mergedItem.NewScheduledDate.getDate() ===
            item.NewScheduledDate.getDate(),
      );

      if (existingItemIndex !== -1) {
        mergedSubscriptionData[existingItemIndex].data = mergedSubscriptionData[
          existingItemIndex
        ].data.concat(item.data);
      } else {
        mergedSubscriptionData.push(item);
      }
    });

    let dataForDays = [];
    const newSchedule = {};
    // Iterate over the schedule array
    mergedSubscriptionData.forEach((item) => {
      dataForDays.push(item.data[0]);
      // Check if the MonthName already exists in newSchedule
      if (!newSchedule[item.MonthName]) {
        // If not, create a new entry with MonthName and MonthData as an array
        newSchedule[item.MonthName] = {
          MonthName: item.MonthName,
          MonthData: [],
        };
      }

      // Push the current item into the corresponding MonthData array
      newSchedule[item.MonthName].MonthData.push({
        eventId: item.eventId || null,
        WeekDay: item.WeekDay,
        NewScheduledDate: item.NewScheduledDate,
        OriginalScheduledDate: item.OriginalScheduledDate,
        data: item.data,
      });
    });

    const finalData = Object.values(newSchedule);

    const days = getNext30Days(dataForDays);
    setDataForDays(dataForDays);
    const activeDayIndex = days.findIndex((e) => e.hasEvents);
    setActiveDay(activeDayIndex);
    setDays(days);

    setSubscriptionEventData(finalData);
  };

  useEffect(() => {
    try {
      fetchInvitation();
      getSubscriptionEvents();
    } catch (err) {
      console.error("Error:", err);
    }
  }, [warningModalToggle]);

  const handleToggleMenu = (item) => {
    setSelectedItem((prevItem) => (prevItem?.guid === item.guid ? null : item));
    setInputNameValue(item.ScheduleDescription);
  };

  const getTimeWithoutSeconds = (dateString) => {
    const date = new Date(dateString);
    const options = { hour: "2-digit", minute: "2-digit", hour12: false };
    const timeWithoutSeconds = date.toLocaleTimeString("en-US", options);
    return timeWithoutSeconds;
  };

  const cancelSession = async () => {
    const eventTime = selectedItem.NewScheduledDate;
    const originalEventTime = selectedItem.OriginalScheduledDate;

    const method = selectedItem.eventId ? patch : post;

    const dataToPass = selectedItem.eventId
      ? {
          id: selectedItem.eventId,
          eventStatus: "Cancelled",
        }
      : {
          scheduleDayId: selectedItem.dayId,
          eventTime: eventTime.toISOString(),
          originalEventTime: originalEventTime.toISOString(),
          eventStatus: "Cancelled",
          scheduleId: selectedItem.scheduleId,
        };

    try {
      const data = await method("/ApplicationEvent", dataToPass);
      if (data) {
        setSelectedItem(null);
        const successMessage = t("consumer_schedules_cancel_success");
        showStatusModal(successMessage);
        getSubscriptionEvents();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const renameSubscription = async () => {
    try {
      const data = await patch("/Subscription", {
        id: selectedItem.subscriptionId,
        description: inputNameValue,
      });
      setWarningModalToggle("modal-warning");
      setWarningModalText(t("consumer_schedules_renamed_warning"));
    } catch (err) {}
  };

  const handleSelectDay = (index, day, hasEvents) => {
    if (!hasEvents) {
      return;
    }
    const formattedEventDates = dataForDays?.map((elem) =>
      format(elem.NewScheduledDate, "EEE dd"),
    );
    const indexInEvents = formattedEventDates.indexOf(day);
    const activeElement = eventsRefs.current[indexInEvents];
    if (activeElement) {
      const rect = activeElement.getBoundingClientRect();
      const absoluteElementTop = rect.top + window.scrollY;
      setScrollByCode(true);
      window.scrollTo({
        top: absoluteElementTop - 140,
        behavior: "smooth",
      });

      setTimeout(() => {
        setScrollByCode(false);
      }, 500);
    }
    setActiveDay(index);
  };

  const handleScroll = () => {
    if (scrollByCode) {
      return;
    }
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const minusPixels = scrollTop > lastScrollTop ? 10 : 50;
    setLastScrollTop(scrollTop <= 0 ? 0 : scrollTop);
    let cumulativeHeight = 0;
    let currentDay = 0;

    for (let i = 0; i < eventsRefs.current.length; i++) {
      if (
        window.scrollY <
        cumulativeHeight + eventsRefs.current[i].offsetHeight - minusPixels
      ) {
        currentDay = i;
        break;
      }
      cumulativeHeight += eventsRefs.current[i].offsetHeight;
    }
    const filteredDays = days.filter((day) => day.hasEvents);

    if (filteredDays.length > 0) {
      const nextIndex = days.findIndex(
        (elem) => elem.date === filteredDays[currentDay].date,
      );
      setActiveDay(nextIndex);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollByCode, days, lastScrollTop]);

  let refsIndex = 0;
  const scrollItems = days.map((item) => ({
    ...item,
    subText: t(item.dayName).slice(0, 3),
  }));

  return (
    <>
      {loading && (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
      <ModalWarning
        warningText={warningModalText}
        modalSubText={
          detectModal === 2 ? t("consumer_schedules_renamed_sub_warning") : ""
        }
        buttonText={detectModal === 2 ? t("go_main_page") : t("go_invitations")}
        changeModal={setWarningModalToggle}
        modalValue={warningModalToggle}
        Image={detectModal === 2 ? Tick : Warning}
        handleButton={
          detectModal === 2
            ? () => {
                navigate("/sessions");
              }
            : () => {
                navigate("/invitation");
              }
        }
      />

      <ModalConfirmation
        modalText={
          detectModal === 1
            ? t("consumer_schedule_cancel_confirm_text")
            : t("consumer_schedule_rename_confirm_text")
        }
        modalSubText={
          detectModal === 1
            ? t("consumer_schedule_cancel_confirm_subtext", {
                time: getTimeWithoutSeconds(selectedItem?.NewScheduledDate),
              })
            : t("consumer_schedule_rename_confirm_subtext")
        }
        inputModal={
          detectModal === 2 ? (
            <ScheduleInviteInput
              label={t("input_label_rename_subscription")}
              value={inputNameValue}
              changeValue={setInputNameValue}
            />
          ) : null
        }
        changeModal={setConfirmModalToggle}
        modalValue={confirmModalToggle}
        confirm={detectModal === 1 ? cancelSession : renameSubscription}
        cancel={() => {
          setSelectedItem(null);
        }}
      />
      <div className="consumer-container">
        <ScrollableItems
          items={scrollItems}
          activeItem={activeDay}
          selectItem={handleSelectDay}
        />
        {subscriptionEventData.length === 0 ? (
          <div className="empty-schedule">
            <h1>{t("consumer_schedules_empty")}</h1>
          </div>
        ) : (
          subscriptionEventData.map((day, Dayindex) => {
            return (
              <div className="schedule-list-container" key={Dayindex}>
                <div className="schedule-day">
                  <span>{t(day.MonthName.toLocaleLowerCase())}</span>
                </div>
                <ul>
                  {day.MonthData.map((item, itemIndex) => {
                    return (
                      <li
                        key={itemIndex}
                        ref={(el) => (eventsRefs.current[refsIndex++] = el)}
                      >
                        {item.data
                          .filter((stat) => stat.Status !== "Cancelled")
                          .map((elem, dIndex) => {
                            return (
                              <div
                                className="sub-single-schedule-container"
                                key={dIndex}
                              >
                                <div className="single-schedule-description">
                                  <span>{elem.ScheduleDescription}</span>
                                </div>
                                <div className="sub-schedule-day-container">
                                  <div className="sub-schedule-day">
                                    <span>
                                      {item.NewScheduledDate.getDate()}
                                    </span>
                                  </div>
                                  <div className="schedule-line"></div>
                                </div>
                                <div className="single-schedule">
                                  <div className="single-schedule-time">
                                    <div className="session-icon">
                                      <RenderActivities
                                        activities={elem.scheduleActivityName}
                                      />
                                    </div>
                                    <span>
                                      {elem.NewScheduledTimeOnly.hour}:
                                      {elem.NewScheduledTimeOnly.minute}
                                    </span>
                                  </div>
                                  <div className="single-schedule-icons">
                                    <div>
                                      <DotsMenu
                                        menuItems={menuItems}
                                        isMenuOpen={
                                          selectedItem?.guid === elem.guid &&
                                          !confirmModalToggle
                                        }
                                        toggleMenu={() =>
                                          handleToggleMenu(elem)
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export default React.memo(ScheduleConsumer);
